import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect } from 'react';
import './listarMinutaGrilla.scss';
import { CustomButton } from '../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';
import { INYECTAR_MINUTAS } from '../../../data/graphQL/mutations/ListarMinuta/injectMinutaASAP';

import { adaptMinutaPeriodoActivo, GET_MINUTA_PERIODO_ACTIVO } from '../../../data/graphQL/queries/GenerarMinuta/getPeriodoMinutaActivo';
import moment from 'moment';

export const ListarMinutaGrillaHeader = ({
  allowedWrite,
  minutasSeleccionadas,
  setRefetchGrilla,
  setSendLoading,
  periodoActivo,
  setPeriodoActivo
}) => {
  const descMes = ["", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  const [getPeriodoActivo, { data: periodoData, loading: periodoLoading }] = useLazyQuery(GET_MINUTA_PERIODO_ACTIVO, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!periodoData) return;
    setPeriodoActivo(periodoData.periodoMinutaActivo != null ? adaptMinutaPeriodoActivo(periodoData.periodoMinutaActivo) : null);
	}, [periodoData]);

  useEffect(() => {
    if (!periodoLoading)
    getPeriodoActivo();
  }, []);

  const [sendMinutas, { loading: sendMinutasLoading }] = useMutation(INYECTAR_MINUTAS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data.insertarMinutaSAP.success) {
        toast.success(data.insertarMinutaSAP.valorEsperado);
        setRefetchGrilla(true);
      } else {
        toast.error(data.insertarMinutaSAP.error);
      }
      setSendLoading(false);
    }
  });

  const getIdsMinutas = (listaMinutas) => {
    let listaIds = [];
    if (listaMinutas.length > 0) {
      listaMinutas.map((nodo) => {
        return listaIds.push(nodo.idMinuta);
      });
    }
    return listaIds;
  };

  const sendValid = () => {
    if (minutasSeleccionadas.length === 0) {
      toast.error("Debe seleccionar al menos una minuta para enviar a SAP.");
      return false;
    }

    return true;
  };

  const handleImprimir = () => {
    if (sendValid() && !sendMinutasLoading) {
      setSendLoading(true);
      sendMinutas({ variables: { minutas: getIdsMinutas(minutasSeleccionadas) } });
    }
  };

  return (
    <div className='top-buttons'>    
            <div className='chip-periodo'>
                {
        periodoActivo == null ?
        <strong>- No existe período activo</strong> :
        <strong>{descMes[periodoActivo?.mes]} {periodoActivo?.anio} ({periodoActivo?.fechaDesde != "" ?
          moment(periodoActivo?.fechaDesde).format("DD/MM/YYYY") : ""} - {periodoActivo?.fechaHasta != "" ? moment(periodoActivo?.fechaHasta).format("DD/MM/YYYY") :

          ""})
                        </strong>
        }
            </div>              
            <CustomButton
        isLoading={sendMinutasLoading}
        disabled={
        !allowedWrite ||
        periodoActivo == null ||
        minutasSeleccionadas == null || minutasSeleccionadas.length === 0
        }
        onClick={handleImprimir}
        variant="outlined">
        
                Pasar minuta a SAP
            </CustomButton>
        </div>);

};